export default "__VITE_ASSET__CkstSWIH__"